export type HeaderAccountSlot = "sign-in" | "account" | "pending";

export function knownAuthenticatedFrom(
    data: { isAuthenticated: boolean } | null | undefined,
): boolean | null {
    if (data == null) return data === null ? false : null;
    return data.isAuthenticated;
}

export function headerAccountSlot(input: {
    sessionPending: boolean;
    sessionSignedIn: boolean;
    knownAuthenticated: boolean | null;
}): HeaderAccountSlot {
    if (!input.sessionPending) {
        return input.sessionSignedIn ? "account" : "sign-in";
    }
    if (input.knownAuthenticated === true) return "account";
    if (input.knownAuthenticated === false) return "sign-in";
    return "pending";
}
